<template>
  <div class="Permissions">
    <div class="content flex-jc-bt">
      <div class="flex-42 left-side">
        <sp-card type="none" custom-class="sp-color-bg-4">
          <div class="card-content">
            <div>
              <div v-triangle class="action-title fw-bold text-left">{{ $l('ActionPermission') }}</div>
              <div class="opacity text-left tips tips-pd">{{ $l('ActionPermissionTip') }}</div>
            </div>
            <div class="pd-l-40">
              <div class="text-left">{{ $l('Delete') }}</div>
              <sp-radio-group v-model="jobInfo.delPriv" name="delPriv" class="option">
                <div class="delete flex-jc-bt">
                  <div class="flex-50 text-left">
                    <sp-radio :disabled="routerQuery.readonly" label-position="right" value="0">
                      <div class="opacity">{{ $l('NotApproved') }}</div>
                    </sp-radio>
                  </div>
                  <div class="flex-50 text-left">
                    <sp-radio :disabled="routerQuery.readonly" label-position="right" value="1">
                      <div class="opacity">{{ $l('Approved') }}</div>
                    </sp-radio>
                  </div>
                </div>
              </sp-radio-group>
            </div>
            <div class="box-border mg-b-20 text-left">
              <sp-icon :width="411" :height="229" type="permission-deleted" />
            </div>
            <div class="mg-t-30 pd-l-40">
              <div class="text-left">{{ $l('PostPublish') }}</div>
              <sp-radio-group v-model="jobInfo.pubPriv" name="pubPriv" class="option">
                <div class="delete flex-jc-bt">
                  <div class="flex-50 text-left">
                    <sp-radio :disabled="routerQuery.readonly" label-position="right" value="1">
                      <div class="opacity">{{ $l('Approved') }}</div>
                    </sp-radio>
                  </div>
                  <div class="flex-50 text-left">
                    <sp-radio :disabled="routerQuery.readonly" label-position="right" value="0">
                      <div class="opacity">{{ $l('NotApproved') }}</div>
                    </sp-radio>
                  </div>
                </div>
              </sp-radio-group>
            </div>
            <div class="box-border mg-b-20 text-left">
              <sp-icon :width="411" :height="229" type="permission-selected" />
            </div>
            <!--            <div class="additional"> -->
            <!--              <div class="pd-b-10 text-left">{{ $l('Additional') }}</div> -->
            <!--              <sp-input type="warn2" text-type="textArea" row="5" /> -->
            <!--            </div> -->
          </div>
        </sp-card>
      </div>
      <div class="flex-56 right-side sp-color-bg-4">
        <SpTableDIY :data-list="dataList">
          <SpTableColumn column-name="DeptAccessIdentity" label="DeptAccessIdentity">
            <template #default="row">
              {{ $l(identity[row.identity]?.title) }}
            </template>
          </SpTableColumn>
          <SpTableColumn column-name="Responsibilities" label="Responsibilities">
            <template #default="row">
              {{ row.profession?.name }}
            </template>
          </SpTableColumn>
          <SpTableColumn column-name="Position" label="Position">
            <template #default="row">
              {{ row.position?.name }}
            </template>
          </SpTableColumn>
          <SpTableColumn column-name="JobDescription" label="JobDescription" width="400">
            <template #default="row">
              <el-popover placement="bottom"
                          :width="388"
                          trigger="hover">
                {{ row.description }}
                <template #reference>
                  <p class="ellipsis-3 label pd-l-10 pd-r-10">
                    {{ row.description }}
                  </p>
                </template>
              </el-popover>
            </template>
          </SpTableColumn>
        </SpTableDIY>
        <div class="pd-t-40">
          <div v-triangle class="text-left">{{ $l('CoverPagePermission') }}</div>
          <div class="mg-t-20">
            <ElementPlusTree
              ref="permissionsTree"
              :default-checked-keys="defaultCheckedKeys"
              :identity="parseInt(jobInfo.identity)"
              :permission="permission"
              :disabled="routerQuery.readonly === 'true'? true : false"
              :state="!routerQuery.id ? 'add' : ''"
              @setCheckedKeys="setCheckedKeys" />
          </div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <sp-button v-if="!routerQuery.readonly" class="mg-t-20" circle-radius="4" html-type="submit" type="primary" :label="$l('Submit')" :bold="-1" :width="333" :height="101" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spCard from '@/components/common/SpCard'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import spIcon from '@/components/common/SpIcon'
import spInput from '@/components/common/SpInput'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import spButton from '@/components/common/SpButton'
import { DEPT_IDENTITY } from '@/config/company'
import ElementPlusTree from '@/components/common/ElementPlusTree'
export default {
  name: 'Permissions',
  nameSpace: 'company.PermissionsSetting.PermissionsName',
  components: {
    ElementPlusTree,
    spCard,
    spRadio,
    spRadioGroup,
    spIcon,
    spInput,
    SpTableDIY,
    SpTableColumn,
    spTag,
    spTagGroup,
    spButton
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    },

    permissionTree: {
      type: Object,
      default: function () {
        return {}
      }
    },

    defaultCheckedKeys: {
      type: Array,
      default () {
        return []
      }
    },

    permission: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      identity: DEPT_IDENTITY,
      // permissionTree: {}, // 权限结构
      allCheck: {}
    }
  },

  computed: {
    routerQuery () {
      return this.$route.query
    },

    jobInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    },

    dataList () {
      return [
        {
          identity: this.jobInfo.identity,
          profession: this.jobInfo.profession,
          position: this.jobInfo.position,
          description: this.jobInfo.description
        }
      ]
    }
  },

  watch: {
    'jobInfo.permissions': {
      handler (val) {
        this.formatPermissionIds(val)
      },

      deep: true
    }

  },

  created () {
  },

  mounted () {
  },

  methods: {
    formatPermissionIds (permissions) {
      const formatPermissionIds = {}
      permissions.forEach(per => {
        if (!formatPermissionIds[per.parentId]) {
          formatPermissionIds[per.parentId] = []
          formatPermissionIds[per.parentId].push(per.id)
        } else {
          formatPermissionIds[per.parentId].push(per.id)
        }
      })
      this.jobInfo.permissionIds = formatPermissionIds
    },

    setCheckedKeys (keys) {
      this.$emit('setCheckedKeys', keys)
    }
  }
}
</script>

<style scoped lang="less">
.Permissions {
  .opacity {
    opacity: .7;
  }
  .content {
    padding: @gap*1.5 @gap*2 @gap @gap*2;
    .left-side {
      .action-title {
        padding: @gap*1.5 @gap*2.5 0 @gap*1.5;
      }
      .tips {
        font-size: 14px;
      }
      .tips-pd {
        word-spacing: 1px;
        padding: 0 @gap*2 @gap @gap*2.5;
      }
      .delete{
        padding: 15px 0 @gap*1.5 0;
      }
      .box-border {
        // box-sizing: border-box;
        margin-left: @gap*2;
        max-width: 411px;
        max-height: 229px;
        border: 1px dashed #666;
      }
      .additional {
        padding: @gap @gap*8 @gap*2 @gap*2;
      }
    }
    .right-side {
      box-sizing: border-box;
      padding: @gap*3.5 @gap/2 @gap*4 @gap*2;
      .attach{
        color: #676767;
        font-size: 14px;
      }
      .tags-font {
        font-size: 14px;
      }
    }
  }
  .buttons {
    padding: @gap*3 @gap*2 0 @gap*5;
  }
}
</style>
